import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Button, Typography, CircularProgress, Alert } from '@mui/material';
import { CheckCircle, Error } from '@mui/icons-material';
import api from '../../api/axiosInstance';

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid or missing verification link.');
      return;
    }

    const verifyEmail = async () => {
      try {
        await api.get(`/auth/verify-email/${token}`);
        setStatus('success');
        setMessage('Your email has been verified successfully! Redirecting to login...');

        // Redirect to login after 2 seconds
        setTimeout(() => {
          navigate('/login', { state: { message: 'Email verified! You can now log in.' } });
        }, 2000);
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Verification failed. The link may have expired.');
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      {status === 'loading' && (
        <>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography variant="h4" fontWeight={700} mb={1.5}>
            Verifying your email...
          </Typography>
          <Typography color="text.secondary">
            Please wait while we verify your email address.
          </Typography>
        </>
      )}

      {status === 'success' && (
        <>
          <CheckCircle sx={{ fontSize: 48, color: 'success.main', mb: 2 }} />
          <Typography variant="h4" fontWeight={700} mb={1.5} color="success.main">
            Email verified!
          </Typography>
          <Typography color="text.secondary" mb={3}>
            {message}
          </Typography>
          <Button variant="contained" component={Link} to="/login" fullWidth>
            Go to Login
          </Button>
        </>
      )}

      {status === 'error' && (
        <>
          <Error sx={{ fontSize: 48, color: 'error.main', mb: 2 }} />
          <Typography variant="h4" fontWeight={700} mb={1.5} color="error.main">
            Verification failed
          </Typography>
          <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
            {message}
          </Alert>
          <Button variant="contained" component={Link} to="/login" fullWidth sx={{ mb: 2 }}>
            Back to Login
          </Button>
        </>
      )}
    </Box>
  );
};

export default VerifyEmailPage;
